var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"not-found mt-15",style:({color: _vm.fontColor})},[_c('v-icon',{attrs:{"size":"96","color":_vm.fontColor}},[_vm._v("mdi-help-box")]),_vm._v(" "+_vm._s(_vm.trans('general.pageNotFound'))+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }